// Reads the API base URL from RUNTIME config (window._env_, written by
// docker-entrypoint.sh the moment the container actually starts) instead
// of the old build-time-baked process.env value.
//
// Falls back to process.env.REACT_APP_API_BASE_URL for local `npm start`
// development — window._env_ only gets generated by the production
// Docker container's entrypoint script, so local dev correctly keeps
// using CRA's normal .env file handling instead.

const runtimeApiBaseUrl =
  typeof window !== "undefined" &&
  window._env_ &&
  window._env_.REACT_APP_API_BASE_URL;

export const API_BASE_URL =
  runtimeApiBaseUrl || process.env.REACT_APP_API_BASE_URL || "";